<neo-card>
  <ng-content />
</neo-card>
